import { render, staticRenderFns } from "./incl-catalogPageElementContentElement.vue?vue&type=template&id=1708201b&scoped=true"
import script from "./incl-catalogPageElementContentElement.vue?vue&type=script&lang=js"
export * from "./incl-catalogPageElementContentElement.vue?vue&type=script&lang=js"
import style0 from "./incl-catalogPageElementContentElement.vue?vue&type=style&index=0&id=1708201b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708201b",
  null
  
)

export default component.exports